import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';


import { AuthenticationProvider } from '../authentication/authentication';
import { take, mergeMap } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs';
import { CoreProvider } from '../core/core.service';
import { ContractsProvider } from './contract';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ContractResolver implements Resolve<any> {
    cardsList: any;
    assetsList: any;
    data: any;
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authenticationService.currentUserData()) {
            return this.contractService.getContractsList().pipe(
                take(1),
                mergeMap(data => {
                    const list: any = data;
                    if (list && list.items.length) {
                        return of(data);
                    } else {
                        this.coreService.presentToastWithOptions(this.translate.instant('MSG22'), 'primary');
                        this.coreService.addClassToBlankMenu('Vertrag');
                        this.router.navigate(['/mydata']);
                        if (this.router.url === '/mydata') {
                            this.coreService.hideLoader();
                        }
                        return EMPTY;
                    }
                })
            );
        }
    }

    constructor(private authenticationService: AuthenticationProvider,
                private contractService: ContractsProvider,
                private coreService: CoreProvider,
                private translate: TranslateService,
                private router: Router) { }
}
